module.exports = __webpack_public_path__ + "img/icon3.2b74a8f9.png";